import React, { useState } from "react";
import Preloader from "../../helper/Preloader";
import Breadcrumb from "../../components/Breadcrumb";
import ShopSectionOne from "../../components/ShopSectionOne";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../../components/HeaderOne";
import ShippingOne from "../../components/ShippingOne";
import FooterOne from "../../components/FooterOne";
import BottomFooter from "../../components/BottomFooter";

import { useLocation } from "react-router-dom";

const ProductListOne = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const categoryId = query.get("category");

  const [selectedCurrency, setSelectedCurrency] = useState(
      localStorage.getItem("selectedCurrency")
    );
  
    const handleCurrencyChange = (currency) => {
      setSelectedCurrency(currency);
      localStorage.setItem("selectedCurrency", currency); 
    };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      {/* <ScrollToTop smooth color="#1E293B" /> */}

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shop"} />

      {/* ShopSection */}
      <ShopSectionOne categoryId={categoryId} selectedCurrency={selectedCurrency} />

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterOne */}
      <FooterOne />

      {/* Bottom Footer */}
      {/* <BottomFooter /> */}
    </>
  );
};

export default ProductListOne;
